import type { Theme } from '../../types/theme';

export const binanceTheme: Theme = {
  id: 'binance',
  name: 'Binance',
  description: 'Dark crypto exchange with bold yellow accents and trading urgency',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/binance/DESIGN.md',
  visualKeywords: ['dark', 'yellow accent', 'trading', 'crypto', 'urgent'],
  colors: {
    background: '#0b0b0b',
    surface: '#1a1a1a',
    surfaceElevated: '#242424',
    textPrimary: '#ffffff',
    textSecondary: '#848484',
    textMuted: '#848484',
    border: '#2a2a2a',
    borderSubtle: '#343434',
    primary: '#f0b90b',
    primaryHover: '#dca500',
    primaryActive: '#d29b00',
    accent: '#f0b90b',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'urgent',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
